module.exports = __webpack_public_path__ + "img/banner4.0bee1058.png";